import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, ExternalLink } from 'lucide-react';

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-border/40 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="w-full flex h-16 items-center justify-between px-4">
        <Link to="/" className="flex items-center gap-2">
          <img src="/icons/logo.svg" alt="App logo" className="h-8 w-auto" />
          <h1 className="text-lg md:text-2xl font-bold">Beredskapshubben <span className="text-muted-foreground">| Blogg</span></h1>
        </Link>

        {/* Hamburger menu */}
        <div className="relative">
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="p-2 rounded-md transition-colors hover:bg-[#67724e]/20"
            aria-label="Meny"
          >
            <Menu className="h-6 w-6" />
          </button>
          
          {/* Dropdown menu */}
          {menuOpen && (
            <>
              <div 
                className="fixed inset-0 z-40" 
                onClick={() => setMenuOpen(false)}
              />
              <div className="absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-popover border z-50">
                <div className="py-1">
                  <a
                    href="https://beredskapshubben.se"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 px-4 py-2 text-sm transition-colors hover:bg-[#67724e]/20"
                    onClick={() => setMenuOpen(false)}
                  >
                    Beredskapshubben
                    <ExternalLink className="h-4 w-4 ml-auto" />
                  </a>
                  <div className="border-t border-border my-1" />
                  <a
                    href="https://beredskapshubben.se/about"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block px-4 py-2 text-sm transition-colors hover:bg-[#67724e]/20"
                    onClick={() => setMenuOpen(false)}
                  >
                    Om oss
                  </a>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
